var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1781 1.30118C25.4594 0.582548 24.3052 0.582548 23.5866 1.30118L13.7335 11.1542L3.88049 1.30118C3.16186 0.582548 2.00761 0.582548 1.28898 1.30118C0.570341 2.01982 0.570341 3.17406 1.28898 3.8927L11.142 13.7457L1.28898 23.5988C0.570341 24.3174 0.570341 25.4717 1.28898 26.1903C1.64025 26.5416 2.11383 26.7322 2.57888 26.7322C3.03893 26.7322 3.51509 26.5566 3.87038 26.1887L13.7218 16.3373L23.5748 26.1903C23.9261 26.5416 24.3997 26.7322 24.8647 26.7322C25.3375 26.7322 25.8017 26.5559 26.1563 26.1886C26.8733 25.4699 26.8727 24.3169 26.1546 23.5988L16.3248 13.746L26.1781 3.8927C26.8967 3.17406 26.8967 2.01982 26.1781 1.30118Z",
    fill: "#FB7C51",
    stroke: "#FB7C51",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon2);
export default __webpack_public_path__ + "static/media/crossIcon2.5ae6aa2c4dd4bf01bca27875e37380c9.svg";
export { ForwardRef as ReactComponent };